import api from './api';

export interface PublicConfig {
  licenseEnabled: boolean;
}

let cachedConfig: PublicConfig | null = null;

export const configService = {
  /**
   * Get public configuration from API
   * Caches the result to avoid repeated requests
   */
  async getPublicConfig(): Promise<PublicConfig> {
    if (cachedConfig !== null) {
      return cachedConfig;
    }

    try {
      const response = await api.get<PublicConfig>('/config/public');
      cachedConfig = response.data;
      return cachedConfig;
    } catch (error) {
      console.error('Failed to fetch public config:', error);
      // Default to license disabled if API call fails
      cachedConfig = { licenseEnabled: false };
      return cachedConfig;
    }
  },

  /**
   * Clear cached config (useful for testing or forced refresh)
   */
  clearCache() {
    cachedConfig = null;
  },
};
